import React from "react";
import {
  Box,
  FormControlLabel,
  MenuItem,
  Select,
  Slider,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

export default function OverlayOptions({ form, onChange, assets, lang }) {
  const set = (patch) => onChange({ ...form, ...patch });

  return (
    <Stack spacing={2}>
      <FormControlLabel
        control={
          <Switch checked={Boolean(form.hookTitle)} onChange={(e) => set({ hookTitle: e.target.checked })} />
        }
        label={lang?.clippingHookTitle || "Hook title overlay"}
      />

      <FormControlLabel
        control={
          <Switch checked={Boolean(form.music)} onChange={(e) => set({ music: e.target.checked })} />
        }
        label={lang?.clippingMusic || "Background music"}
      />
      {form.music && (
        <Stack spacing={1.5} sx={{ pl: 1 }}>
          <Box>
            <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>
              {lang?.clippingMusicTrack || "Music track"}
            </Typography>
            <Select
              fullWidth
              size="small"
              value={form.musicName || ""}
              onChange={(e) => set({ musicName: e.target.value })}
              displayEmpty
            >
              <MenuItem value="">{lang?.clippingSelectMusic || "Select track…"}</MenuItem>
              {(assets.music || []).map((t) => (
                <MenuItem key={t.name} value={t.name}>
                  {t.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              {lang?.clippingMusicVolume || "Music volume"}: {form.musicVolume ?? 50}
            </Typography>
            <Slider
              value={form.musicVolume ?? 50}
              min={0}
              max={100}
              onChange={(_, v) => set({ musicVolume: v })}
            />
          </Box>
        </Stack>
      )}

      <FormControlLabel
        control={
          <Switch
            checked={Boolean(form.gameVideo)}
            onChange={(e) => set({ gameVideo: e.target.checked })}
          />
        }
        label={lang?.clippingGameVideo || "Gameplay overlay"}
      />
      {form.gameVideo && (
        <Box sx={{ pl: 1 }}>
          <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>
            {lang?.clippingGameVideoName || "Game video"}
          </Typography>
          <Select
            fullWidth
            size="small"
            value={form.gameVideoName || ""}
            onChange={(e) => set({ gameVideoName: e.target.value })}
            displayEmpty
          >
            <MenuItem value="">{lang?.clippingSelectGame || "Select overlay…"}</MenuItem>
            {(assets.gameVideos || []).map((t) => (
              <MenuItem key={t.name} value={t.name}>
                {t.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}

      <FormControlLabel
        control={
          <Switch checked={Boolean(form.memeHook)} onChange={(e) => set({ memeHook: e.target.checked })} />
        }
        label={lang?.clippingMemeHook || "Meme hook"}
      />
      {form.memeHook && (
        <Box sx={{ pl: 1 }}>
          <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>
            {lang?.clippingMemeHookName || "Meme hook"}
          </Typography>
          <Select
            fullWidth
            size="small"
            value={form.memeHookName || ""}
            onChange={(e) => set({ memeHookName: e.target.value })}
            displayEmpty
          >
            <MenuItem value="">{lang?.clippingSelectMeme || "Select hook…"}</MenuItem>
            {(assets.memeHooks || []).map((t) => (
              <MenuItem key={t.name} value={t.name}>
                {t.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}

      <FormControlLabel
        control={
          <Switch checked={Boolean(form.ctaEnabled)} onChange={(e) => set({ ctaEnabled: e.target.checked })} />
        }
        label={lang?.clippingCta || "Call-to-action overlay"}
      />
      {form.ctaEnabled && (
        <TextField
          fullWidth
          size="small"
          placeholder={lang?.clippingCtaPlaceholder || "Shop now, link in bio…"}
          value={form.ctaText || ""}
          onChange={(e) => set({ ctaText: e.target.value.slice(0, 200) })}
          helperText={`${(form.ctaText || "").length} / 200`}
        />
      )}
    </Stack>
  );
}
